import { Box, Spinner, Table } from '@salecycle/ui-component-library';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Role } from 'sections/user-management/sections/roles/data/roles-constants';
import { getRoleTableColumns } from './RoleTableColumns';

interface IProps {
  roles: Role[];
  rolesLoading: boolean;
}

interface ITableUserRoleData {
  id: string;
  name: string;
  description: string;
  createdAt: string;
}

export const RoleTable: React.FC<IProps> = (props: IProps) => {
  const { t } = useTranslation();
  const { push } = useHistory();
  const [pageNumber, setPageNumber] = React.useState(0);
  const tableRoleData: ITableUserRoleData[] = props?.roles?.map(role => ({
    id: role.id,
    name: role.name,
    description: role.description,
    createdAt: role.createdAt,
  }));
  return (
    <>
      <Table
        columns={getRoleTableColumns(t, push)}
        data={tableRoleData}
        defaultPageSize={10}
        defaultSorted={[{ id: 'name', desc: false }]}
        noDataText={props.rolesLoading ? '' : t('userManagement.roles.view.table.noData')}
        loading={props.rolesLoading}
        loadingText={t('userManagement.roles.view.table.loadingText')}
        page={pageNumber}
        onPageChange={(pageIndex: number): void => {
          setPageNumber(pageIndex);
        }}
      />
      {props.rolesLoading && (
        <Box verticalPositioning="center" horizontalPositioning="center">
          <Spinner />
        </Box>
      )}
    </>
  );
};
